import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { SharedService } from './shared.service';

@Injectable({
    providedIn: 'root'
})
export class GlobalService {

    public globalQueryParams: any;

    constructor(private sharedService: SharedService, private readonly router: Router, private readonly route: ActivatedRoute) { }

    public getQueryParamsAndSaveToVariable(queryparams: any) {
        this.globalQueryParams = queryparams;
    }

    /** Generates the Panelist Payload for panelist_user_choices and panelist_profiling Collection
    * @param {*Object choiceObj - either choice key or piiFormDetails key will be sent
    * @param {*boolean terminate
    * @returns {Array} - Array of two Panelist Payload objects
    */
    public createPanelistPayload = (choiceObj: any, terminate: any) => {
        const panelistUserObj = {
            ...choiceObj,
            grp_id: Number.parseInt(this.sharedService.rootData.grp_id),
            PID: this.sharedService.rootData.PID,
            supCode: this.sharedService.rootData.supCode,
            uid: this.sharedService.rootData.uid,
            isTerminate: terminate,
            cnt: this.sharedService.rootData.countryCode,
            lang: this.globalQueryParams?.Lang?.toUpperCase() || "ENGLISH",
            deviceId: this.sharedService.rootData.RVID
        };
        const panelistProfileObj = {
            ...choiceObj,
            PID: this.sharedService.rootData.PID,
            supCode: this.sharedService.rootData.supCode,
            grp_id: Number.parseInt(this.sharedService.rootData.grp_id),
            uid: this.sharedService.rootData.uid,
            cnt: this.sharedService.rootData.countryCode,
            lang: this.globalQueryParams?.Lang?.toUpperCase() || "ENGLISH"
        };
        return [panelistUserObj, panelistProfileObj];
    };

    /**
      * For call fetchGroupDetails
      */
    public fetchGroupDetails(grpId: any) {
        return new Promise((resolve, reject) => {
            let $that = this;
            if (!grpId
                || $that.sharedService.rootData.grp_id === $that.sharedService.rootData.currentGrpId) {
                return resolve(null);
            }
                this.sharedService.getGrpDetails(this.sharedService.rootData.grp_id, this.sharedService.rootData.oeQues)
                    .subscribe({
                        next(group: any) {
                            $that.sharedService.rootData.currentGrpId = $that.sharedService.rootData.grp_id;
                            $that.sharedService.rootData.group = group.grpDetail;
                            $that.sharedService.rootData.isPega = group.grpDetail.isPega;
                            if (!!$that.sharedService.rootData.isOEValidation && !!$that.sharedService.rootData.oeThresholdLevel) {
                                return resolve(null);
                            }
                                $that.sharedService.getJobDetails(group.grpDetail.jb_id)
                                    .subscribe({
                                        next(jobObj: any) {
                                            $that.sharedService.rootData.jb_id = jobObj.job.id;
                                            $that.sharedService.rootData.jobDetailsObj = jobObj.job;
                                            if (isNaN($that.sharedService.rootData.supCode)) {
                                                return resolve(null);
                                            }
                                                $that.sharedService.getSuplierByCondition($that.sharedService.rootData.supCode)
                                                    .subscribe({
                                                        next(data: any) {
                                                            $that.sharedService.rootData.isOEValidation = jobObj.job.chkOeValid ? (data?.result?.dsblTA) ? 0 : 1 : 0;
                                                            $that.sharedService.rootData.oeThreshLev = jobObj.job.oeThreshLev;
                                                            // APICC-70 Fetch oeThreshold level from supplier level, on the basis of country code, group type, supplier code basis
                                                            if (!$that.sharedService.rootData.isOEValidation) {
                                                                return resolve(null);
                                                            }
                                                                const obj = {
                                                                    supId: $that.sharedService.rootData.supCode,
                                                                    cnt: $that.sharedService.rootData.countryCode,
                                                                    grpTp: $that.sharedService.rootData.group.grp_typ
                                                                }
                                                                $that.sharedService.getOeThresholdFromSupplier(obj)
                                                                    .subscribe({
                                                                        next(result: any) {
                                                                            $that.sharedService.rootData.oeThreshLev =
                                                                                result?.supplierOeThreshLev
                                                                                    ? result.supplierOeThreshLev
                                                                                    : jobObj.job.oeThreshLev;
                                                                            resolve(null);
                                                                        },
                                                                        error(err: any) {
                                                                            console.error('error in fetching job details', err);
                                                                            resolve(null);
                                                                        }
                                                                    });
                                                            /*} else {
                                                                resolve(null);
                                                            }*/
                                                        },
                                                        error(err: any) {
                                                            console.error('error in fetching job details', err);
                                                            resolve(null);
                                                        }
                                                    });
                                            /*} else {
                                                resolve(null);
                                            }*/
                                        },
                                        error(err: any) {
                                            console.error('error in fetching job details', err);
                                            resolve(null);
                                        }
                                    });
                            /*} else {
                                resolve(null);
                            }*/
                        },
                        error(err: any) {
                            console.error('error in fetching group details', err);
                            resolve(null);
                        }
                    });
            /*} else {
                resolve(null);
            }*/
        });
    }

    //Function to add/update panelist profiling in panelist_profile collection
    //Here we also setup rating scale and terminate/allowed the repondent based on rating scale if same respondent comes with same supplier.
    public updatePanelistProfiling(payload: any) {
        if (!this.sharedService.rootData.Test) {
            this.sharedService.updateAllPanelistProfile(payload)
                .subscribe({
                    next(data: any) {
                    },
                    error(error: any) {
                        console.error("ERROR in updatePanelistProfiling ", error);
                    }
                });
        } else {
            console.info("updatePanelistProfiling: Panelist Profile will not stored for test survey");
        }
    }

    // Function to syncing data instantly as user completes all profiling questions.
    public syncProfilingQus() {
        this.sharedService.syncProfilingQusWithPc(Number.parseInt(this.sharedService.rootData.grp_id), this.sharedService.rootData.PID, this.sharedService.rootData.supCode, this.sharedService.rootData.uid).subscribe({
            next(data: any) {
            },
            error(error) {
                console.error("ERROR in syncProfilingQusWithPc ", error);
            }
        });
    }

}
